import React from 'react'

import { motion } from "framer-motion";
import { mobilenav, mobilenavItem } from "../../../motion-varients/mobilenav"
import { Link } from "react-router-dom"



export default function AnimatedList({ toggleOpen }) {

    return (
      <motion.ul
        variants={mobilenav}
        initial="closed"
        animate="open"
        exit="closed"
      >
        <motion.li variants={mobilenavItem}>
          <Link to="/" onClick={() => toggleOpen()}>
            Home
          </Link>
        </motion.li>
        <motion.li variants={mobilenavItem}>
          <Link to="/about" onClick={() => toggleOpen()}>
            About
          </Link>
        </motion.li>
        {/* <motion.li variants={mobilenavItem}><Link to="/projects" onClick={() => toggleOpen()}>Projects</Link></motion.li> */}
        <motion.li variants={mobilenavItem}>
          <Link to="/contact" onClick={() => toggleOpen()}>
            Contact
          </Link>
        </motion.li>
      </motion.ul>
    );
}
